class EntityIdentifier {
    type;
    value;
    constructor(response) {
        this.type = response.type;
        this.value = response.value;
    }
}
export default EntityIdentifier;
